import React from 'react';
import styled from 'styled-components';
import { themeable } from 'themes/utils';

interface CardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    link?: string;
}

const CardWrapper = styled.div`
    background: ${themeable('bodyBackgroundColor')};
    border-radius: 12px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-size: 18px;
    width: 330px;
`;

const CardHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const IconWrapper = styled.div``;

const Title = styled.div`
    color: #7b8ec8;
    font-weight: 600;
`;

const Description = styled.div``;

export const CardsGrid = styled.div`
    margin-bottom: 40px;
    display: flex;
    flex-flow: row wrap;
    gap: 16px;
    justify-content: center;
`;

export const Card: React.FC<CardProps> = ({
    icon,
    title,
    description,
    link
}) => {
    const content = (
        <CardWrapper>
            <CardHeader>
                <IconWrapper>{icon}</IconWrapper>
                <Title>{title}</Title>
            </CardHeader>
            <Description>{description}</Description>
        </CardWrapper>
    );

    if (link) {
        return (
            <a href={link} style={{ textDecoration: 'none' }}>
                {content}
            </a>
        );
    }
    return content;
};
